/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { NullableOneOfPropertyOfStorageLocation } from './NullableOneOfPropertyOfStorageLocation';
import {
    instanceOfNullableOneOfPropertyOfStorageLocation,
    NullableOneOfPropertyOfStorageLocationFromJSON,
    NullableOneOfPropertyOfStorageLocationFromJSONTyped,
    NullableOneOfPropertyOfStorageLocationToJSON,
} from './NullableOneOfPropertyOfStorageLocation';

/**
 * @type CreateOtherMvTherapyMachineDtoImageLocation
 * 
 * @export
 */
export type CreateOtherMvTherapyMachineDtoImageLocation = NullableOneOfPropertyOfStorageLocation;


export function CreateOtherMvTherapyMachineDtoImageLocationFromJSON(json: any): CreateOtherMvTherapyMachineDtoImageLocation {
    return CreateOtherMvTherapyMachineDtoImageLocationFromJSONTyped(json, false);
}

export function CreateOtherMvTherapyMachineDtoImageLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOtherMvTherapyMachineDtoImageLocation {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...NullableOneOfPropertyOfStorageLocationFromJSONTyped(json, true) };
    return  NullableOneOfPropertyOfStorageLocationFromJSONTyped(json, true);
}

export function CreateOtherMvTherapyMachineDtoImageLocationToJSON(value?: CreateOtherMvTherapyMachineDtoImageLocation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfNullableOneOfPropertyOfStorageLocation(value)) {
        return NullableOneOfPropertyOfStorageLocationToJSON(value as NullableOneOfPropertyOfStorageLocation);
    }

    return {};
}

/**
 * Check if a given object implements the CreateOtherMvTherapyMachineDtoImageLocation interface.
 */
export function instanceOfCreateOtherMvTherapyMachineDtoImageLocation(value: any): value is CreateOtherMvTherapyMachineDtoImageLocation {
    if (instanceOfNullableOneOfPropertyOfStorageLocation(value)) return true;
    return false;
}

